import { connectSession } from "../handlers/session";
import { initOutBoundCall } from "./call";
import { changeAgentStateToAvailable } from "../handlers/agent";
import Emitter from "../../emitter";
import {
  API_CALLBACK_DIAL,
  API_CALLBACK_REJECT,
  API_CALLBACK_UPDATE,
  API_TASK_ANSWER_ERROR,
  CHANNEL_TYPES,
  CONTACT_EVENT_STATE_MAP,
  LOG_PREFIX,
  TELEMETRY_ERROR,
  TELEMETRY_INFO,
} from "../constants";
import { updateCallbackAndSend } from "../handlers/callback";
import { API_CONTACT_EVENT_LOGGING } from "../../constants/events";

const lp = LOG_PREFIX + "[api.callback.ts] ";

function getAgentContactById(id: string) {
  const contacts = connectSession.agent.getContacts(connect.ContactType.TASK);
  if (contacts.length > 0) {
    return contacts.find((ct: any) => ct.contactId === id);
  }
  return null;
}

export function acceptTaskContact(ev: any) {
  const logPrefix = lp + "acceptTaskContact " + ev.body.conversationId;
  console.log(
    logPrefix + "Accept Callback contact",
    getAgentContactById(ev.body.conversationId)
  );
  try {
    const taskContact = getAgentContactById(ev.body.conversationId);
    if (taskContact) {
      taskContact.accept({
        success: function () {
          Emitter.emit(TELEMETRY_ERROR, {
            type: "notif",
            chan: TELEMETRY_INFO,
            body: {
              type: API_CALLBACK_UPDATE,
              body: {
                message: logPrefix + ` Callback answer via streams`,
              },
            },
          });
          console.log(
            logPrefix + "Callback Accepted via Streams, callbackContact = ",
            taskContact
          );
        },
        failure: function (error: any) {
          console.log(
            logPrefix + "Failed to establish connection via Streams",
            error
          );
          Emitter.emit(TELEMETRY_ERROR, {
            type: "notif",
            chan: TELEMETRY_ERROR,
            body: {
              type: API_TASK_ANSWER_ERROR,
              body: {
                error: error?.toString(),
                message: logPrefix + `Callback answer failed`,
              },
            },
          });
          updateCallbackAndSend(
            CONTACT_EVENT_STATE_MAP.ENDED,
            ev.body.conversationId
          );
          disconnectCallbackContact(ev);
        },
      });
    } else {
      clearCurrentCallbackContact(ev?.body?.conversationId);
      updateCallbackAndSend(
        CONTACT_EVENT_STATE_MAP.ENDED,
        ev.body.conversationId
      );
      console.log(
        logPrefix +
          "No callback contact found with contactId = " +
          ev.body.conversationId
      );
    }
  } catch (e) {
    clearCurrentCallbackContact(ev?.body?.conversationId);
    updateCallbackAndSend(
      CONTACT_EVENT_STATE_MAP.ENDED,
      ev.body.conversationId
    );
    console.log(
      logPrefix +
        "No callback contact found with contactId = " +
        ev.body.conversationId,
      e
    );
  }
}

export function disconnectCallbackContact(ev: any) {
  const logPrefix = lp + "disconnectCallbackContact " + ev.body.conversationId;
  try {
    const taskContact = getAgentContactById(ev.body.conversationId);
    if (taskContact) {
      const taskAgentConn = taskContact.getAgentConnection();
      if (taskAgentConn) {
        taskAgentConn.destroy({
          success: function () {
            console.log(
              logPrefix +
                "Rejected Incoming call via Streams successfully, taskContact = ",
              taskContact
            );
            taskContact.clear({
              success: () => {},
              failure: (error: any) => {
                clearCurrentCallbackContact(ev?.body?.conversationId);
                updateCallbackAndSend(CONTACT_EVENT_STATE_MAP.ENDED, {
                  contactId: ev.body.conversationId,
                });
              },
            });
          },
          failure: function (err: any) {
            updateCallbackAndSend(CONTACT_EVENT_STATE_MAP.ENDED, {
              contactId: ev.body.conversationId,
            });
          },
        });
      } else {
        console.log(
          logPrefix + "Error while clearing Task: taskAgentConn not found"
        );
        clearCurrentCallbackContact(ev?.body?.conversationId);
        updateCallbackAndSend(CONTACT_EVENT_STATE_MAP.ENDED, {
          contactId: ev.body.conversationId,
        });
      }
    } else {
      console.log(
        logPrefix + "Error while clearing Task: taskContact not found"
      );
      clearCurrentCallbackContact(ev?.body?.conversationId);
      updateCallbackAndSend(CONTACT_EVENT_STATE_MAP.ENDED, {
        contactId: ev.body.conversationId,
      });
    }
  } catch (error) {
    console.log(logPrefix + "Error while clearing Task", error);
    clearCurrentCallbackContact(ev?.body?.conversationId);
    updateCallbackAndSend(CONTACT_EVENT_STATE_MAP.ENDED, {
      contactId: ev.body.conversationId,
    });
  }
}

export function clearCurrentCallbackContact(contactId: string) {
  const contact = getAgentContactById(contactId);
  if (contact) {
    // TODO handle ended task, because clear api might fail for ended task
    try {
      contact.clear();
    } catch (e) {
      console.log(lp + "Failed to clear contact", e);
    }
  } else {
    console.log("Error cannot clear contact, no contact exists");
  }
}

function rejectCallbackContact(ev: any) {
  changeAgentStateToAvailable();
  disconnectCallbackContact(ev);
  const contact = getAgentContactById(ev?.body?.conversationId);
  if (contact) {
    Emitter.emit(API_CONTACT_EVENT_LOGGING, {
      body: {
        contactId: contact.contactId || contact.getContactId(),
        eventType: CONTACT_EVENT_STATE_MAP.REJECTED,
        channel: CHANNEL_TYPES.CALLBACK,
      },
    });
  }
}

function updateCallbackContact(ev: any) {
  if (ev.body.state === "connected") {
    acceptTaskContact(ev);
  } else if (ev.body.state === "disconnected") {
    disconnectCallbackContact(ev);
  }
}

export function dialCallback(ev: any) {
  initOutBoundCall(ev);
}

export function clearCallbackContactFromAICOnly(contactId: string) {
  updateCallbackAndSend(CONTACT_EVENT_STATE_MAP.ENDED, {
    contactId: contactId,
  });
}

export default function registerCallbackHandlers() {
  Emitter.on(API_CALLBACK_UPDATE, updateCallbackContact);
  Emitter.on(API_CALLBACK_REJECT, rejectCallbackContact);
  Emitter.on(API_CALLBACK_DIAL, dialCallback);
}
